/**
 *
 * PlansDialog
 *
 */

import React, { memo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import classnames from 'classnames';
import styles from './styles';

function PlansDialog({
  classes,
  title = '',
  children,
  className = null,
  open,
  handleClose,
  dialogSmallFlag,
  dialogBigFlag,
  dialogMediumFlag,
  isScroll,
  styleHeightContainerFlag,
  closeIcon = false,
}) {
  const dialogClasses = classnames(classes.dialog, {
    [classes.dialogSmall]: dialogSmallFlag,
    [classes.dialogMedium]: dialogMediumFlag,
    [classes.dialogBig]: dialogBigFlag,
    [className]: className,
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: styleHeightContainerFlag ? classes.styleHeightContainer : '' }}
      className={dialogClasses}
      scroll={isScroll ? 'paper' : 'body'}
    >
      {closeIcon && (
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon style={{ fontSize: 46 }} />
        </IconButton>
      )}
      <MuiDialogTitle disableTypography className={classes.dialogTitle}>
        {Boolean(title) && <p className={classes.dialogLabel}>{title}</p>}
      </MuiDialogTitle>
      <MuiDialogContent className={classes.dialogCont}>{children}</MuiDialogContent>
    </Dialog>
  );
}

PlansDialog.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  dialogBigFlag: PropTypes.bool,
  dialogSmallFlag: PropTypes.bool,
  dialogMediumFlag: PropTypes.bool,
  closeIcon: PropTypes.bool,
  isScroll: PropTypes.bool,
  styleHeightContainerFlag: PropTypes.bool,
  className: PropTypes.string,
};

const PlansDialogStyled = withStyles(styles)(PlansDialog);

export default memo(PlansDialogStyled);
